import './index.css';
import './config/icons'; // Register FontAwesome icons before any components render
import App from './App';
import { ThemeProvider } from 'styled-components';
import theme from './theme';
import { createRoot } from 'react-dom/client';
import { errorLoggingService } from './services/errorLoggingService';

// Register global error handlers early so pre-React errors are buffered
window.onerror = (message, source, lineno, colno, error) => {
    errorLoggingService.logError(
        'onerror',
        typeof message === 'string' ? message : 'Unknown error',
        source ?? undefined,
        lineno,
        colno,
        error?.stack
    );
};

window.onunhandledrejection = (event: PromiseRejectionEvent) => {
    const reason = event.reason;
    const message = reason instanceof Error ? reason.message : String(reason ?? 'Unhandled promise rejection');
    const stack = reason instanceof Error ? reason.stack : undefined;

    errorLoggingService.logError('unhandledrejection', message, undefined, null, null, stack);
};

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <ThemeProvider theme={theme}>
        <App />
    </ThemeProvider>
);
